import { useGetBranchList } from '../../screens/Claims/LossAndDamage/hooks';
import FormSelectBox from '../Inputs/FormSelectBox';

const LADClaimsBranchByDivisionRegionSelector = ({
  placeholder = 'Select Branch',
  label = 'Branch',
  rules = [],
  name,
  editMode,
  margin,
  onChange,
  value = '',
  className = '',
  tabIndex,
  mode = '',
  disableValidation = false,
  divisionKey,
  regionKey,
}) => {
  const { data: options = [], isLoading } = useGetBranchList({ divisionKey, regionKey });

  return (
    <FormSelectBox
      loading={isLoading}
      options={options}
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      editMode={editMode}
      onChange={onChange}
      value={value}
      mode={mode}
      className={className}
      tabIndex={tabIndex}
      disableValidation={disableValidation}
    />
  );
};

export default LADClaimsBranchByDivisionRegionSelector;
